<template>
  <div class="event-subexponent-reader-message" v-if="show">
    <div class="event-subexponent-reader-message__container container">
      <icon name="info-grey" />

      <div class="event-subexponent-reader-message__container-text">
        <p
          class="event-subexponent-reader-message__container-text-item"
          v-html="$t('event.subexpReadNotification.title')"
        ></p>

        <p
          class="event-subexponent-reader-message__container-text-item"
          v-html="$t('event.subexpReadNotification.description')"
        ></p>
      </div>

      <button
        class="event-subexponent-reader-message__container-btn"
        @click="hide"
      >
        <icon name="delete" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

const HAS_SEEN_KEY_TPL = "subexponent-{id}-has-seen-reader-msg-splash";

export default {
  name: "EventSubexponentReaderMessage",

  data: () => ({
    show: false
  }),

  computed: {
    ...mapGetters("event", ["eventId"])
  },

  methods: {
    hide() {
      this.show = false;
      localStorage.setItem(HAS_SEEN_KEY_TPL.replace("id", this.eventId), true);
    }
  },

  mounted() {
    // показываем только в первый раз
    if (!localStorage.getItem(HAS_SEEN_KEY_TPL.replace("id", this.eventId))) {
      this.show = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";

.event-subexponent-reader-message {
  border-radius: 2px;
  background-color: rgba(#f1f1f1, 0.5);

  &__container {
    padding: 21px 0 19px 0;
    display: flex;
    align-items: center;

    &-text {
      &-item {
        margin: 4px 0 4px 0;
        padding: 0;

        span {
          font-weight: 500;
        }
      }
    }

    .svg-icon {
      width: 32px;
      height: 32px;
      margin-right: 16px;

      flex-shrink: 0;
    }

    &-btn {
      @include button-clean();

      margin-left: auto;

      .svg-icon {
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>
